module.exports = __webpack_public_path__ + "static/media/capture_selected.0e318967.svg";